import { BID, CID } from '@/constants/statistics';

export const AGREEMENT_TYPE = {
  SupplementalAgreement: 1, //  美团充电宝合作协议之补充协议
  SubjectChangeAgreement: 2, //  美团充电宝主体变更补充协议
  CooperationRenewAgreement: 3, //  美团充电宝合作续签协议
};

export const AGREEMENT_TYPE_DESC = {
  [AGREEMENT_TYPE.SupplementalAgreement]: {
    name: '美团充电宝合作协议之补充协议',
    routerName: 'SupplyAgreement', //  协议路由名，与@/router中协议注册路由的name相匹配
    sendMessageApiName: 'sendMessageForKaSupply', //  发送短信的api名，与@/api/agreement中的方法名相匹配
    signApiName: 'signAdditional', //  签署协议的api名，与@/api/agreement中的方法名相匹配
    withPhoneCall: true, //  带不带联系方式
    pageViewCid: CID.SupplementalAgreement, //  页面埋点信息
    agreeButtonBid: BID.SUPPLEMENTAL_AGREE_BUTTON, //  同意按钮埋点
    disagreeButtonBid: BID.SUPPLEMENTAL_DISAGREE_BUTTON, //  不同意按钮埋点
    exitButtonBid: BID.SUPPLEMENTAL_EXIT_BUTTON, //  退出按钮埋点
    toAgreementBid: BID.SUPPLEMENTAL_AGREEMENT_PREVIEW_BUTTON, //  点击预览协议埋点
  },
  [AGREEMENT_TYPE.SubjectChangeAgreement]: {
    name: '美团充电宝主体变更补充协议',
    routerName: 'SubjectChangeAgreement', //  协议路由名，与@/router中协议注册路由的name相匹配
    sendMessageApiName: 'sendMessageForSubjectChange', //  发送短信的api名，与@/api/agreement中的方法名相匹配
    signApiName: 'signChangeSubjectAgreement', //  签署协议的api名，与@/api/agreement中的方法名相匹配
    pageViewCid: CID.SubjectChangeAgreement, //  页面埋点信息
    agreeButtonBid: BID.SUBJECT_CHANGE_AGREE_BUTTON, //  同意按钮埋点
    disagreeButtonBid: BID.SUBJECT_CHANGE_DISAGREE_BUTTON, //  不同意按钮埋点
    exitButtonBid: BID.SUBJECT_CHANGE_EXIT_BUTTON, //  退出按钮埋点
    toAgreementBid: BID.SUBJECT_AGREEMENT_PREVIEW_BUTTON, //  点击预览协议埋点
  },
  [AGREEMENT_TYPE.CooperationRenewAgreement]: {
    name: '美团充电宝合作协议',
    routerName: 'AgreementPreviewTemplate', //  协议路由名，与@/router中协议注册路由的name相匹配
    sendMessageApiName: 'sendMessageForRenewCooperationAgreement', //  发送短信的api名，与@/api/agreement中的方法名相匹配
    signApiName: 'renewCooperationAgreement', //  签署协议的api名，与@/api/agreement中的方法名相匹配
    previewAgreementApiName: 'previewCooperationRenewAgreement', //  预览协议的api名, 与@/api/agreement中的方法名相匹配
    pageViewCid: CID.CooperationRenewAgreement, //  页面埋点信息
    agreeButtonBid: BID.COOPERATION_RENEW_AGREE_BUTTON, //  同意按钮埋点
    disagreeButtonBid: BID.COOPERATION_RENEW_DISAGREE_BUTTON, //  不同意按钮埋点
    exitButtonBid: BID.COOPERATION_RENEW_EXIT_BUTTON, //  退出按钮埋点
    toAgreementBid: BID.COOPERATION_AGREEMENT_PREVIEW_BUTTON, //  点击预览协议埋点
  },
};
